// extracted by mini-css-extract-plugin
module.exports = {"bottomSection":"Discovery-Feed_bottomSection__t0XTG","name":"Discovery-Feed_name__dmQm2","price":"Discovery-Feed_price__P7i_q","bgColor":"Discovery-Feed_bgColor__oZ7NU"};